import fetch from '../../plugins/axios'
export default {
	namespaced: true,
	state: {
		shelves: [],
		info: {},
		userList: [],
		customerList: [],
		customerPager: {},
		loading: false, 
		printList: [],
		printPager: {}
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		},
	},
	getters:{
		eorderNum(state){
			const arr = state.printList.map(item => item.quantity);
			let res = 0;
			for(const i in arr){
				res = res + arr[i]
			}
			return res;
		}
	},
	actions: {
		// 获得用户信息列表
		async getUserList({ commit }: any) {
			const res = await fetch({
				url: '/client/user'
			})
			commit('setState',{key:'userList',data:res})
		},
		// 新增用户
		async addNewUser({ commit }: any, params: any) {
			return await fetch({
				url: `/client/user`,
				method: 'post',
				data: params
			})
		},
		// 修改登陆信息
		async modifyLogin({ commit }: any, params: any) {
			return await fetch({
				url: `/client/user/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 获取vip货架
		async getVipShelf({}, params){
			 return await fetch({
				url: '/client/vipshelf',
					params
			})
		},
		// 修复货架
		async modifyVipShelf({}, data){
			return await fetch({
				url: '/client/vipshelf',
				method: 'put',
				data,
			})
		},
		// 删除货架
		async removeVipShelf({}, id){
			return await fetch({
				url: `/client/vipshelf/${id}`,
				method: 'delete',
			})
		},
		// 获取vip货架
		async createVipShelf({}, data){
			return await fetch({
				url: '/client/vipshelf',
				method: 'post',
				data
			})
		},
		// 获得网点信息
		async getCheckAuth({ commit }: any, params: any) {
			const res:any = await fetch({
				url: '/client/site/self'
			})
			commit('setState',{key:'info',data:res})
		},
		// 修改网点信息
		async modifyCheckAuth({ commit }: any, params: any) {
			return await fetch({
				url: '/client/site/self',
				method: 'put',
				data: params
			})
		},
		// 获取货架
		async getShelves({ commit }: any, params: any) {
			const res = await fetch({
				url: '/client/shelf'
			})
			commit('setState',{key: 'shelves',data: res})
		},
		// 添加货架
		async addShelves({ dispatch,commit }: any, params: any) {
			await fetch({
				url: '/client/shelf',
				method: 'post',
				data: params
			})
			dispatch('getShelves')
			return true
		},
		// 删除货架
		async deletShelves({ dispatch,commit }: any, id: any) {
			await fetch({
				url: `/client/shelf/${id}`,
				method: 'delete'
			})
			dispatch('getShelves')
			return true
		},
		// 修改货架
		async modifyShelves({ dispatch,commit }: any, params: any) {
			console.log(params);
			await fetch({
				url: `/client/shelf/${params.id}`,
				method: 'put',
				data: params.data
			})
			dispatch('getShelves')
			return true
		},
		// 获取客户列表
		async getCustomerList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: `/client/customphone`,
				method: 'get',
				params
			})
			commit('setState',{key: 'customerList',data: res.docs})
			commit('setState',{key:'customerPager',data: {limit: res.limit,total: res.total}})
            commit('setState',{key:'loading',data: false})
		},
		// 修改客户信息
		async modifyCustomer({ commit }: any, params: any) {
			return await fetch({
				url: `/client/customphone/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 添加客户信息
		async addCustomer({ commit }: any, params: any) {
			return await fetch({
				url: `/client/customphone`,
				method: 'post',
				data: params
			})
		},
		
		// 加入黑名单
		async addBlack({ commit }: any, params: any) {
			return await fetch({
				url: `/client/customphone/${params.id}`,
				method: 'put',
				data: params.data
			})
		},
		// 删除客户
		async deleteCustomer({ commit }: any, id: string) {
			return await fetch({
				url: `/client/customphone/${id}`,
				method: 'delete'
			})
		},
		// 获得电子面单记录
		async getPrintList({ commit }: any) {
			const res:any = await fetch({
				url: `/client/eorder/eorderQuery`,
				method: 'get'
			})
			commit('setState',{key: 'printList',data: res})
            commit('setState',{key:'loading',data: false})
		},
	}
}